function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.667 10.667h-4L20 5.333h-2.667L20 10.667h-4l-2.667-5.334h-2.666l2.666 5.334h-4L6.667 5.333H5.333A2.663 2.663 0 002.68 8l-.013 16c0 1.467 1.2 2.667 2.666 2.667h21.334c1.466 0 2.666-1.2 2.666-2.667V5.333H24l2.667 5.334zm-11.44 10.24L13.827 24l-1.4-3.093-3.094-1.4 3.094-1.4 1.4-3.094 1.4 3.094 3.093 1.4-3.093 1.4zm4.213-3.08l.707-1.547 1.546-.693-1.546-.707-.707-1.547-.707 1.534-1.546.706 1.546.707.707 1.547z",
  fill: "#000"
});

function SvgAccessTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
}

export default SvgAccessTime;